const HIGHLIGHT_BASE_COLORS = [
  [230, 25, 75],
  [60, 180, 75],
  [0, 130, 200],
  [245, 130, 48],
  [145, 30, 180],
  [240, 200, 0],
  [0, 180, 180],
  [128, 0, 0],
  [0, 100, 0],
  [0, 0, 180],
  [220, 100, 180],
  [170, 110, 40],
  [100, 100, 100],
] as const

const OVERLAY_OPACITY = 0.3
const MARKER_OPACITY = 0.5

export const HIGHLIGHT_COLORS = HIGHLIGHT_BASE_COLORS.map(([r, g, b]) => {
  const overlay = `rgba(${r}, ${g}, ${b}, ${OVERLAY_OPACITY})`
  const border = `rgba(${r}, ${g}, ${b}, 0.85)`
  const marker = `rgba(${r}, ${g}, ${b}, ${MARKER_OPACITY})`
  return { fill: overlay, border, marker }
})

export const getHighlightColor = (colorIndex: number) =>
  HIGHLIGHT_COLORS[colorIndex % HIGHLIGHT_COLORS.length]
